import React from 'react';
import { useTranslate } from '../hooks/useTranslate';

interface TProps {
  children: string;
}

/**
 * Translation component for simple text nodes
 */
const T: React.FC<TProps> = ({ children }) => {
  const translated = useTranslate(children);
  return <>{translated}</>;
};

export default T;
